'use client';

import { BellAlertIcon } from '@heroicons/react/24/solid';
import { toast } from 'react-toastify';
import {
  useGetApiPlayers,
  usePostApiPlayersSendEmailConfirmation,
} from '@/api/backoffice/players/players';
import { Button } from './button';
import { PageContent } from './PageContent';

export const ConfirmEmailAlert = () => {
  const { data, error } = useGetApiPlayers({
    query: {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
  });

  const { mutateAsync: sendEmailConfirmation, isPending } =
    usePostApiPlayersSendEmailConfirmation({
      mutation: {
        onSuccess: () => {
          toast.success('Email confirmation link sent successfully');
        },
        onError: () => {
          toast.error('Failed to send email confirmation link');
        },
      },
    });

  if (!data || error) {
    return null;
  }

  if (!data.data.emailConfirmed) {
    return (
      <PageContent>
        <div className="flex w-full flex-wrap items-center justify-between gap-4 rounded-lg bg-yellow-300 p-4 text-black">
          <div className="flex flex-wrap items-center gap-4">
            <BellAlertIcon className="size-6 text-black" />
            <span className="font-medium">
              You need to confirm your email before doing any actions on our
              website (pickems, etc.)
            </span>
          </div>

          <Button
            className="hover:bg-light-gray"
            disabled={isPending}
            onClick={() =>
              sendEmailConfirmation({
                data: {
                  url: window.location.origin,
                },
              })
            }
            size="sm"
          >
            Resend verification email
          </Button>
        </div>
      </PageContent>
    );
  }

  return null;
};
